//  $(document).ready(function () {


    $(".split-heading,.split-text").each(function () {
        var el = $(this);
        var text = el.data("text");

        el.html("");

        // $.each(text.split(""), function (i, char) {
        //     var span = $("<span>" + char + "</span>");
        //     span.css("animation-delay", (i * 0.07) + "s");
        //     el.append(span);
        // });
        $.each(text.split(""), function (i, char) {
          if (char === " ") {
              el.append('<span class="space">&nbsp;</span>');
          } else {
              var span = $("<span>" + char + "</span>");
              span.css("animation-delay", (i * 0.07) + "s");
              el.append(span);
          }
      });

    });

//--- Before/After with text ---/

// Select ALL image comparison sliders
const imageComparisonSliders = document.querySelectorAll('[data-component="image-comparison-slider"]');

function setSliderstate(e, element) {
  const sliderRange = element.querySelector('[data-image-comparison-range]');
  if (e.type === 'input') {
    sliderRange.classList.add('image-comparison__range--active');
    return;
  }
  sliderRange.classList.remove('image-comparison__range--active');
  element.removeEventListener('mousemove', moveSliderThumb);
}

function moveSliderThumb(e) {
  const element = e.currentTarget.closest('[data-component="image-comparison-slider"]');
  const sliderRange = element.querySelector('[data-image-comparison-range]');
  const thumb = element.querySelector('[data-image-comparison-thumb]');
  let position = e.layerY - 20;
  if (e.layerY <= sliderRange.offsetTop) {
    position = -20;
  }
  if (e.layerY >= sliderRange.offsetHeight) {
    position = sliderRange.offsetHeight - 20;
  }
  // thumb.style.top = `${position}px`;
}

function moveSliderRange(e, element) {
  const value = e.target.value;
  const slider = element.querySelector('[data-image-comparison-slider]');
  const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');

  slider.style.left = `${value}%`;
  imageWrapperOverlay.style.width = `${value}%`;

  element.addEventListener('mousemove', moveSliderThumb);
  setSliderstate(e, element);
}

function init(element) {
  const sliderRange = element.querySelector('[data-image-comparison-range]');

  if ('ontouchstart' in window === false) {
    sliderRange.addEventListener('mouseup', e => setSliderstate(e, element));
    sliderRange.addEventListener('mousedown', moveSliderThumb);
  }

  sliderRange.addEventListener('input', e => moveSliderRange(e, element));
  sliderRange.addEventListener('change', e => moveSliderRange(e, element));
}

// Loop through all sliders and initialize each one
imageComparisonSliders.forEach(init);




/*=========Collection tab========= */

        $('.tab-title').on('click', function () {


            var targetTab = $(this).data('index');


            //var targetTabId = targetTab.split(' ')[0].toLowerCase();


            $(this).parent().closest('.collection-tab-inner').find('.tab-title').removeClass('active');


            $(this).addClass('active');

             $(this).parent().closest('.collection-tab-inner').find('.collection-list-tab__content .tab-pane').removeClass('active').fadeOut(300);
            $(".collection-tab-products[data-index='" + targetTab + "']").addClass("tab-active").fadeIn(400);

            //$('#coll-index-"'+targetTab+'"').addClass('active').fadeIn(400);


              setTimeout(function() {
                    $(".collection-tab-products[data-index='" + targetTab + "']").find('.product-slick-slider').slick('setPosition');
              }, 50);
           
        });


  // tab-scroll

        const slider = document.querySelector('.collection-list__tabs');
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
        isDown = false;
        });

        slider.addEventListener('mouseup', () => {
        isDown = false;
        });

        slider.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; // speed
        slider.scrollLeft = scrollLeft - walk;
       });



// has image
    $('.has-image .product-slick-slider').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                rows: 2,
                responsive: [
                  {
                      breakpoint: 991,
                      settings: {
                          rows: 1,
                          slidesToShow: 2,
                          slidesToScroll: 1
                      }
                  },
                  {
                      breakpoint: 480,
                      settings: {
                          rows: 1,
                          slidesToShow: 2,
                          slidesToScroll: 1
                      }
                  }
                 
                  ]

        });


        // has no image

        $('.collection-list-tab__content').each(function () {
          const slider = $(this).find('.has-no-image .product-slick-slider');
          const slidesToShow = parseInt(slider.data('slides-to-show'));

          slider.slick({
                      dots: false,
                      arrows: false,
                      infinite: true,
                      speed: 300,
                      slidesToShow: slidesToShow,
                      slidesToScroll: 2,
                      rows: 2,
                      responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                rows: 2,
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                rows: 2,
                                slidesToShow: 2
                             
                            }
                        }
                      
                        ]

              });


              
        });

        

if ($(window).width() <= 480) {
const desktopSlider = $('.single_mobile_slider').find('.has-no-image .product-slick-slider');
        if (desktopSlider.hasClass('slick-initialized')) {
          desktopSlider.slick('unslick');


        desktopSlider.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        initialSlide: 0.5
      });
        }
}




/*=========Image slider========= */

        $('.collection-banner-slider-wrapper.slider-enable').slick({
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            prevArrow: '<button class="slick-arrows slick-prev"> <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" viewBox="0 0 24 24" fill="none"><path d="M3.20624 13.0138C2.9317 12.731 2.93082 12.27 3.2062 11.9862L6.8808 8.21135C7.156 7.92865 7.60122 7.92963 7.87519 8.21382C8.14913 8.49794 8.14808 8.95748 7.87284 9.24026L5.40621 11.7742H20.2969C20.6852 11.7742 21 12.0991 21 12.5C21 12.9009 20.6852 13.2258 20.2969 13.2258H5.40617L7.87287 15.7597C8.14811 16.0425 8.14917 16.5021 7.87523 16.7862C7.60126 17.0703 7.15607 17.0714 6.88084 16.7886L3.20624 13.0138Z" fill="currentColor"></path></svg></button>',
            nextArrow: '<button class="slick-arrows slick-next"> <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" viewBox="0 0 24 24" fill="none" style="transform: rotate(180deg);"><path d="M3.20624 13.0138C2.9317 12.731 2.93082 12.27 3.2062 11.9862L6.8808 8.21135C7.156 7.92865 7.60122 7.92963 7.87519 8.21382C8.14913 8.49794 8.14808 8.95748 7.87284 9.24026L5.40621 11.7742H20.2969C20.6852 11.7742 21 12.0991 21 12.5C21 12.9009 20.6852 13.2258 20.2969 13.2258H5.40617L7.87287 15.7597C8.14811 16.0425 8.14917 16.5021 7.87523 16.7862C7.60126 17.0703 7.15607 17.0714 6.88084 16.7886L3.20624 13.0138Z" fill="currentColor"></path></svg></button>'
        });
       

/*========= Scrolling text========= */
  $(".tt-scrolling-text").each(function () {
  var $tt_stSpeed = $(this).data("scroll-speed");
  $(this)
    .find(".tt-scrolling-text-inner")
    .css({
      "animation-duration": $tt_stSpeed + "s"
    });
});


/*========= product slider(countdown)========= */

    $('.collection__product-slider.slider_active').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                  {
                      breakpoint: 991,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1
                      }
                  },
                  {
                      breakpoint: 480,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                      }
                  }
                 
                  ]

        });


/*========= Hotspot slider========= */

      $('.hotspot-banner-slider').slick({
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
           prevArrow: '<button class="slick-arrows slick-prev"> <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" viewBox="0 0 24 24" fill="none"><path d="M3.20624 13.0138C2.9317 12.731 2.93082 12.27 3.2062 11.9862L6.8808 8.21135C7.156 7.92865 7.60122 7.92963 7.87519 8.21382C8.14913 8.49794 8.14808 8.95748 7.87284 9.24026L5.40621 11.7742H20.2969C20.6852 11.7742 21 12.0991 21 12.5C21 12.9009 20.6852 13.2258 20.2969 13.2258H5.40617L7.87287 15.7597C8.14811 16.0425 8.14917 16.5021 7.87523 16.7862C7.60126 17.0703 7.15607 17.0714 6.88084 16.7886L3.20624 13.0138Z" fill="currentColor"></path></svg></button>',
          nextArrow: '<button class="slick-arrows slick-next"> <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" viewBox="0 0 24 24" fill="none" style="transform: rotate(180deg);"><path d="M3.20624 13.0138C2.9317 12.731 2.93082 12.27 3.2062 11.9862L6.8808 8.21135C7.156 7.92865 7.60122 7.92963 7.87519 8.21382C8.14913 8.49794 8.14808 8.95748 7.87284 9.24026L5.40621 11.7742H20.2969C20.6852 11.7742 21 12.0991 21 12.5C21 12.9009 20.6852 13.2258 20.2969 13.2258H5.40617L7.87287 15.7597C8.14811 16.0425 8.14917 16.5021 7.87523 16.7862C7.60126 17.0703 7.15607 17.0714 6.88084 16.7886L3.20624 13.0138Z" fill="currentColor"></path></svg></button>'
      });

// Hotspot product Popup
            $('.hotspot-dot').on('click', function (e) {
                e.stopPropagation();

                // Pehle sab bandh karo — important
                $('.hotspot-popup').removeClass('active');

                // Fir jis dot par click hua wahi open hoga
                let popupID = $(this).data('popup');
                $('#' + popupID).addClass('active');
            });

            // CLOSE ON CLOSE BUTTON
            $('.popup-close').on('click', function (e) {
                e.stopPropagation();
                $('.hotspot-popup').removeClass('active');
            });

            // STOP CLICK INSIDE POPUP
            $('.hotspot-popup-inner').on('click', function (e) {
                e.stopPropagation();
            });

            // CLOSE ON BODY CLICK
            $('body').on('click', function () {
                $('.hotspot-popup').removeClass('active');
            });

            // CLOSE POPUP WHEN SLIDE CHANGES
            $('.hotspot-banner-slider').on('afterChange', function () {
                $('.hotspot-popup').removeClass('active');
            });



function splitAndAnimate() {
    $(".heading-split-text").each(function () {
      var el = $(this);
 
      // Only animate once
      if (!el.hasClass("animated")) {
        var topOfElement = el.offset().top;
        var bottomOfWindow = $(window).scrollTop() + $(window).height();
 
        if (bottomOfWindow > topOfElement + 50) {
          el.addClass("animated");
 
          var text = el.text().trim();
          el.html(""); // clear original text
 
          // Split by words
          var words = text.split(/\s+/);
          $.each(words, function (i, word) {
            var span = $("<span>" + word + "</span>");
            span.css("animation-delay", (i * 0.1) + "s"); // stagger per word
            el.append(span);
          });
        }
      }
    });
  }
 
  $(window).on("scroll load", splitAndAnimate);


//  $('body').on('click','.view_more_artist .view-all-btn', function(e) {
// //alert('click');
//     e.preventDefault();
//     $(this).hide();
//     $('.blog-post__item').slideDown();
    
// });













//}); /* document ready */


document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".variant-option__button-label input[type='radio']").forEach(input => {
    input.addEventListener("mouseover", function () {

      console.log("=====change=====");

      const card = this.closest(".product-card-item");

      const jsonEl = card?.querySelector(".product-card-json");

      if (!jsonEl) return;

      const variants = JSON.parse(jsonEl.textContent);

      const variantId = this.dataset.variantId;
      const variant = variants.find(v => v.id == variantId);


      if (!variant || !variant.featured_image) return;

      const cardImage = card.querySelector(".product-card_media img");
      cardImage.src = variant.featured_image.src;
      cardImage.alt = variant.featured_image.alt || "";
    });
  });

});



/*========= Sticky ATC ========= */

  // const $stickySection = $('.add-to-cart-component-sticky');
  // let isClosed = false;

  // function isOutOfView($el) {
  //   if (!$el.length) return true;
  //   const rect = $el[0].getBoundingClientRect();
  //   return rect.bottom < 0 || rect.top > window.innerHeight;
  // }

  // function getCurrentForm() {
  //   let $form = $('.buy-buttons-block add-to-cart-component');
  //   if ($(window).width() <= 991) {
  //     $form = $('.buy-buttons-block add-to-cart-component');
  //   } else {
  //     $form = $('.buy-buttons-block add-to-cart-component');
  //   }

  //   if ($form.is(':visible')) {
  //     return $form;
  //   } else {
  //     return $(); // empty jQuery object
  //   }
  // }

  // function handleStickyToggle() {
  //   if (isClosed) return;

  //   const $form = getCurrentForm();

  //   if (isOutOfView($form)) {
  //     $stickySection.addClass('show').removeClass('hide');
  //   } else {
  //     $stickySection.removeClass('show').addClass('hide');
  //   }
  // }

  // $(window).on('scroll resize orientationchange', handleStickyToggle);
  // $(window).on('load', function () {
  //   setTimeout(handleStickyToggle, 200);
  // });
